module.exports = __webpack_public_path__ + "static/media/img-01.9ad92361.jpg";